var pt_br = {
    values: {
        'Qualifier': 'Qualificador',
        'Lookup table for expected inspector count': 'Lookup table para número esperado de fiscais',
        'SITOP code': 'Código SITOP',
        'Update rig state': 'Atualizar estado da sonda',
        'Recommendations / Observations': 'Recomendações / Observações',
        'Critical Pendencies': 'Pendências Críticas',
        'Search Interval': 'Intervalo de Busca (minutos)',
        'Message': 'Mensagem'
    }
};

module.exports = pt_br;
